<template>
    <section class="hero cd-hero is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only">
        <div class="hero-body">
            <section class="section">
                <div class="container">
                    <div class="columns">
                        <div class="column is-10">
                            <br>
                            <br>
                    <div class="deposit-products-box">
                            <p class="title hero-title">
                                Certificates of Deposit
                            </p>
                            <p class="subtitle hero-subtitle">
                               WebBank offers certificates of deposit (CDs)
                               with features and rates that help you do more with your money.
                            </p>
                        </div>
                    </div>
                    </div>

                </div>
            </section>
        </div>
    </section>

    <div class="blue-bg is-hidden-widescreen">
        <img src="https://assets.webbank.com/cd-hero2.png">
        <section class="section">
            <div class="container">
                <p class="title hero-title-mobile">
                    Certificates of Deposit
                </p>
                            <p class="subtitle hero-subtitle-mobile">
                               WebBank offers certificates of deposit (CDs)
                               with features and rates that help you do more with your money.
                            </p>
            </div>
        </section>
    </div>

    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-8">
                    <div class="content">
                    <h3 class="is-size-1 has-text-primary section-title">Check Out Our Certificates of Deposit Features  </h3>
                    <br>
                    <ul>
                        <li>No monthly fee</li>
                        <li>Competitive interest rates</li>
                        <li>Interest compounded daily for faster savings growth</li>
                        <li>Convenient online account management</li>
                        <li>FDIC insured deposits up to maximum allowed by law</li>
                        <li>Choice of five terms: 6 months, 1 year, 2 years, 3 years, and 5 years</li>
                    </ul>
                    </div>
                </div>
                <div class="column has-text-centered">

                        <div class="box wb-box">
                            <br>
                            <br>
                            <br>
                            <span class="icon diff-icon"><i class="fa-light fa-coins fa-4x"></i></span>
                            <br>
                            <br>
                            <h4 class="box-title">Rates and Fees</h4>
                            <p class="">We offer competitive rates and no monthly fees.</p>
                            <br>
                            <router-link to="/rates-fees" class="button is-primary">Learn More</router-link>
                        </div>
                </div>
            </div>
        </div>
    </section>
    <br>
</template>

<script>
export default {

    created() {
        document.title = "Certificates of Deposit - WebBank";
    },

}
</script>
